import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/payroll/declarations',
}).lazy(() => import('./declarations.index.lazy').then((d) => d.Route))
